import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonagpurcab() {



    const cardData = {





keyword: "Mumbai to Nagpur Cab",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Mumbai to Nagpur Cab Service for business travel, family trips, corporate journeys, educational visits, and long-distance outstation travel. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a smooth journey from Mumbai to Nagpur. With experienced drivers, well-maintained cars, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support, we ensure a safe and comfortable travel experience. Whether you need a one-way taxi, round trip cab, airport transfer, or customized Maharashtra tour, Shreesha Tours & Travels provides dependable cab services from Mumbai to Nagpur.",

topPlaces: [
  {
    title: "Deekshabhoomi Nagpur",
    description: "Deekshabhoomi is one of Nagpur's most important historical and religious landmarks, known as the place where Dr. B. R. Ambedkar embraced Buddhism along with thousands of followers. The magnificent stupa architecture, peaceful surroundings, and cultural significance attract visitors from across India. Travelers visiting Nagpur often include Deekshabhoomi as a major sightseeing and spiritual destination."
  },
  {
    title: "Raman Science Centre Nagpur",
    description: "Raman Science Centre is a popular educational and interactive attraction in Nagpur, designed to promote science learning through exhibitions, planetarium shows, and innovative displays. It is a great destination for students, families, and children looking for an informative and enjoyable experience during their Nagpur visit."
  },
  {
    title: "Futala Lake Nagpur",
    description: "Futala Lake is one of Nagpur's most popular leisure destinations, famous for its beautiful evening views, fountains, food stalls, and peaceful atmosphere. Locals and tourists visit this location to enjoy relaxing walks, photography, and scenic surroundings. It is an ideal place for families and couples exploring Nagpur city."
  },
  {
    title: "Tadoba Andhari Tiger Reserve",
    description: "Tadoba Andhari Tiger Reserve near Nagpur is one of Maharashtra's best wildlife destinations, famous for tiger sightings, jungle safaris, diverse wildlife, and natural landscapes. Wildlife enthusiasts and photographers from across India visit this reserve for unforgettable safari experiences. Many travelers combine their Nagpur trip with a Tadoba wildlife tour."
  },
  {
    title: "Zero Mile Stone Nagpur",
    description: "Zero Mile Stone is a historic landmark located in the center of Nagpur and represents the geographical importance of the city. Built during the British era, this monument attracts history lovers and tourists interested in exploring Nagpur's heritage. It is one of the unique attractions included in city sightseeing tours."
  },
  {
    title: "Ambazari Lake Nagpur",
    description: "Ambazari Lake is one of Nagpur's largest and most beautiful lakes, surrounded by greenery and recreational areas. Visitors enjoy boating, peaceful walks, photography, and relaxing moments near the waterfront. The destination is popular among families and nature lovers looking for a refreshing city escape."
  },
  {
    title: "Ramtek Temple",
    description: "Ramtek is a historic and religious destination near Nagpur known for the ancient Ram Temple located on a hilltop. The area offers beautiful views, peaceful surroundings, and connections with Hindu mythology. Travelers visiting Nagpur often include Ramtek for its spiritual importance and scenic beauty."
  },
  {
    title: "Pench National Park",
    "description": "Pench National Park is a famous wildlife destination near Nagpur, known for forests, tiger safaris, leopards, deer, and diverse bird species. Inspired by the landscapes mentioned in Rudyard Kipling's The Jungle Book, the park attracts wildlife lovers and adventure seekers. It is an excellent addition to a Nagpur outstation tour."
  },
  {
    title: "Khindsi Lake",
    description: "Khindsi Lake near Nagpur is a beautiful nature destination offering boating, water activities, resorts, and peaceful surroundings. It is a popular weekend getaway for families, friends, and corporate groups. The scenic environment makes it perfect for relaxation and outdoor activities."
  },
  {
    title: "Wardha Sevagram Ashram",
    description: "Sevagram Ashram in Wardha is a historically important destination associated with Mahatma Gandhi and India's freedom movement. Visitors can explore Gandhi's residence, historical exhibits, and peaceful surroundings. It is a meaningful cultural stop for travelers interested in India's history and heritage."
  }
],


"services": [
  {
    "name": "Mumbai to Nagpur Cab Booking",
    "description": "Book Mumbai to Nagpur Cab Booking for comfortable and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, Luxury Cab, and Tempo Traveller options for business trips, family journeys, airport transfers, sightseeing, and one-way or round-trip travel."
  },
  {
    "name": "Mumbai to Nagpur Cab Service",
    "description": "Choose Mumbai to Nagpur Cab Service for safe and affordable intercity transportation with experienced drivers and premium vehicles. Enjoy doorstep pickup, flexible booking, transparent pricing, and comfortable travel options for families, corporate travelers, tourists, and regular passengers."
  },
  {
    "name": "Mumbai to Nagpur Taxi",
    "description": "Reserve Mumbai to Nagpur Taxi for smooth highway travel with professional chauffeurs and clean AC cars. Get reliable taxi service with multiple vehicle choices suitable for personal trips, business travel, and outstation journeys."
  },
  {
    "name": "Mumbai to Nagpur Cab",
    "description": "Book Mumbai to Nagpur Cab for private and comfortable travel between Mumbai and Nagpur. Enjoy experienced drivers, spacious vehicles, affordable fares, and convenient pickup locations across Mumbai."
  },
  {
    "name": "Mumbai to Nagpur Taxi Service",
    "description": "Hire Mumbai to Nagpur Taxi Service for dependable long-distance transportation with verified chauffeurs and well-maintained vehicles. Perfect for family trips, corporate travel, airport transfers, and Nagpur sightseeing tours."
  },
  {
    "name": "Mumbai to Nagpur One Way Cab",
    "description": "Book Mumbai to Nagpur One Way Cab for economical drop taxi service without return charges. Travel comfortably with professional drivers, clean vehicles, and flexible pickup timings."
  },
  {
    "name": "Mumbai to Nagpur Car Rental",
    "description": "Choose Mumbai to Nagpur Car Rental for chauffeur-driven vehicles with flexible travel options. Get Sedan, SUV, Innova, Ertiga, Innova Crysta, and luxury cars for comfortable interstate journeys."
  },
  {
    "name": "Mumbai to Nagpur Outstation Cab",
    "description": "Reserve Mumbai to Nagpur Outstation Cab for safe and convenient long-distance travel. Enjoy premium AC vehicles, experienced chauffeurs, affordable pricing, and reliable service for personal and business requirements."
  },
  {
    "name": "Mumbai to Nagpur Private Taxi",
    "description": "Book Mumbai to Nagpur Private Taxi for a comfortable and personalized travel experience. Enjoy direct pickup, private vehicle facilities, professional drivers, and hassle-free outstation transportation."
  },
  {
    "name": "Mumbai to Nagpur Innova Cab",
    "description": "Hire Mumbai to Nagpur Innova Cab for spacious and comfortable travel with family and groups. Enjoy extra luggage space, premium seating, AC comfort, and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Nagpur Innova Crysta Cab",
    "description": "Choose Mumbai to Nagpur Innova Crysta Cab for luxury long-distance travel with premium interiors and superior comfort. Ideal for families, corporate travelers, and passengers looking for a smooth journey."
  },
  {
    "name": "Mumbai to Nagpur Ertiga Cab",
    "description": "Book Mumbai to Nagpur Ertiga Cab for affordable family travel with comfortable seating and spacious interiors. Enjoy reliable chauffeur-driven service for long-distance journeys."
  },
  {
    "name": "Mumbai to Nagpur Sedan Cab",
    "description": "Reserve Mumbai to Nagpur Sedan Cab for budget-friendly travel with clean AC sedan cars and professional drivers. Suitable for couples, small families, and business travelers."
  },
  {
    "name": "Mumbai to Nagpur Swift Dzire Cab",
    "description": "Book Mumbai to Nagpur Swift Dzire Cab for economical and comfortable travel with experienced chauffeurs. Enjoy smooth rides, affordable fares, and reliable sedan cab service."
  },
  {
    "name": "Mumbai to Nagpur SUV Taxi",
    "description": "Hire Mumbai to Nagpur SUV Taxi for spacious and comfortable travel with premium features. Perfect for families, groups, and passengers carrying extra luggage."
  },
  {
    "name": "Mumbai to Nagpur Kia Carens Cab",
    "description": "Choose Mumbai to Nagpur Kia Carens Cab for premium family travel with modern features and comfortable seating. Enjoy a smooth journey with professional chauffeur service."
  },
  {
    "name": "Mumbai to Nagpur Luxury Cab",
    "description": "Book Mumbai to Nagpur Luxury Cab for premium interstate travel with high-comfort vehicles and professional drivers. Enjoy a refined travel experience for business and personal journeys."
  },
  {
    "name": "Mumbai to Nagpur AC Taxi",
    "description": "Reserve Mumbai to Nagpur AC Taxi for comfortable travel in clean air-conditioned vehicles. Enjoy safe transportation with experienced chauffeurs and flexible booking options."
  },
  {
    "name": "Mumbai to Nagpur Tempo Traveller",
    "description": "Book Mumbai to Nagpur Tempo Traveller for group travel with spacious seating and comfortable interiors. Ideal for family tours, corporate groups, and Nagpur sightseeing trips."
  },
  {
    "name": "Mumbai Airport to Nagpur Cab",
    "description": "Hire Mumbai Airport to Nagpur Cab for direct airport pickup and drop services. Get punctual pickups, professional drivers, luggage assistance, and comfortable vehicles for a hassle-free journey."
  },
  {
    "name": "Mumbai International Airport to Nagpur Cab",
    "description": "Book Mumbai International Airport to Nagpur Cab for reliable airport transfer services with experienced chauffeurs. Enjoy smooth travel from the airport to Nagpur with premium AC vehicles."
  },
  {
    "name": "Navi Mumbai to Nagpur Cab",
    "description": "Reserve Navi Mumbai to Nagpur Cab for convenient outstation travel with doorstep pickup and professional drivers. Enjoy comfortable journeys with multiple vehicle options."
  },
  {
    "name": "Thane to Nagpur Cab",
    "description": "Book Thane to Nagpur Cab for safe and comfortable transportation with experienced chauffeurs. Get reliable long-distance cab services from Thane to Nagpur."
  },
  {
    "name": "Panvel to Nagpur Taxi",
    "description": "Choose Panvel to Nagpur Taxi for affordable and convenient travel with clean AC vehicles. Enjoy smooth highway journeys with professional drivers."
  },
  {
    "name": "Kalyan to Nagpur Cab",
    "description": "Hire Kalyan to Nagpur Cab for comfortable interstate travel with flexible booking options. Suitable for family trips, business travel, and personal journeys."
  },
  {
    "name": "Dombivli to Nagpur Taxi",
    "description": "Book Dombivli to Nagpur Taxi for reliable outstation travel with experienced drivers and comfortable vehicles. Enjoy affordable fares and safe transportation."
  },
  {
    "name": "Borivali to Nagpur Cab",
    "description": "Reserve Borivali to Nagpur Cab for convenient long-distance travel with professional chauffeurs. Get comfortable AC vehicles for personal and business trips."
  },
  {
    "name": "Andheri to Nagpur Cab",
    "description": "Choose Andheri to Nagpur Cab for direct and comfortable travel with experienced drivers. Enjoy reliable pickup service and premium vehicles for your journey."
  },
  {
    "name": "Mumbai to Nagpur Tourist Cab",
    "description": "Book Mumbai to Nagpur Tourist Cab for sightseeing and holiday travel with customized routes. Explore Nagpur attractions comfortably with private chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Deekshabhoomi Nagpur Cab",
    "description": "Reserve Mumbai to Deekshabhoomi Nagpur Cab for convenient religious and tourist travel. Enjoy comfortable vehicles, experienced drivers, and hassle-free transportation to Deekshabhoomi."
  },
  {
    "name": "Mumbai to Ramtek Cab",
    "description": "Book Mumbai to Ramtek Cab for comfortable travel to the famous Ramtek destination. Get reliable outstation cab service with professional drivers and clean vehicles."
  },
  {
    "name": "Mumbai to Tadoba Cab Service",
    "description": "Choose Mumbai to Tadoba Cab Service for wildlife tourism travel with comfortable vehicles and experienced chauffeurs. Enjoy safe transportation for Tadoba safari and nature trips."
  },
  {
    "name": "Mumbai to Tadoba Safari Cab",
    "description": "Book Mumbai to Tadoba Safari Cab for convenient wildlife exploration trips. Travel comfortably with private cabs, professional drivers, and flexible safari tour arrangements."
  },
  {
    "name": "Mumbai to Nagpur Sightseeing Taxi",
    "description": "Reserve Mumbai to Nagpur Sightseeing Taxi for exploring Nagpur attractions with a private chauffeur. Enjoy flexible schedules, comfortable vehicles, and customized sightseeing plans."
  },
  {
    "name": "Mumbai to Pench National Park Cab",
    "description": "Hire Mumbai to Pench National Park Cab for wildlife tours and adventure trips. Travel safely with experienced drivers and comfortable vehicles suitable for long-distance journeys."
  },
  {
    "name": "Mumbai to Nagpur Tour Package",
    "description": "Book Mumbai to Nagpur Tour Package by Cab for customized travel experiences including sightseeing, family vacations, and Vidarbha exploration. Enjoy private vehicles with professional drivers."
  },
  {
    "name": "Mumbai to Nagpur Holiday Cab",
    "description": "Choose Mumbai to Nagpur Holiday Cab for comfortable vacation travel with family and friends. Get spacious vehicles, flexible routes, and reliable chauffeur-driven service."
  },
  {
    "name": "Mumbai to Vidarbha Tour Cab",
    "description": "Book Mumbai to Vidarbha Tour Cab for exploring Nagpur and nearby destinations comfortably. Enjoy private transportation, experienced drivers, and customized travel plans."
  }
],
"tableData": [
  ["Mumbai to Nagpur Cab Booking", "Mumbai to Nagpur Cab Service"],
  ["Mumbai to Nagpur Taxi", "Mumbai to Nagpur Cab"],
  ["Mumbai to Nagpur Taxi Service", "Mumbai to Nagpur One Way Cab"],
  ["Mumbai to Nagpur Car Rental", "Mumbai to Nagpur Outstation Cab"],
  ["Mumbai to Nagpur Private Taxi", "Mumbai to Nagpur Innova Cab"],
  ["Mumbai to Nagpur Innova Crysta Cab", "Mumbai to Nagpur Ertiga Cab"],
  ["Mumbai to Nagpur Sedan Cab", "Mumbai to Nagpur Swift Dzire Cab"],
  ["Mumbai to Nagpur SUV Taxi", "Mumbai to Nagpur Kia Carens Cab"],
  ["Mumbai to Nagpur Luxury Cab", "Mumbai to Nagpur AC Taxi"],
  ["Mumbai to Nagpur Tempo Traveller", "Mumbai Airport to Nagpur Cab"],
  ["Mumbai International Airport to Nagpur Cab", "Navi Mumbai to Nagpur Cab"],
  ["Thane to Nagpur Cab", "Panvel to Nagpur Taxi"],
  ["Kalyan to Nagpur Cab", "Dombivli to Nagpur Taxi"],
  ["Borivali to Nagpur Cab", "Andheri to Nagpur Cab"],
  ["Mumbai to Nagpur Tourist Cab", "Mumbai to Deekshabhoomi Nagpur Cab"],
  ["Mumbai to Ramtek Cab", "Mumbai to Tadoba Cab Service"],
  ["Mumbai to Tadoba Safari Cab", "Mumbai to Nagpur Sightseeing Taxi"],
  ["Mumbai to Pench National Park Cab", "Mumbai to Nagpur Tour Package"],
  ["Mumbai to Nagpur Holiday Cab", "Mumbai to Vidarbha Tour Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Nagpur Cab Service",
    WhyChoosedescription: "Shreesha Travels provides comfortable Mumbai to Nagpur cab services for families, business travellers, students, and groups. Enjoy a safe and convenient long-distance journey with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Direct Door-to-Door Travel Service",
    WhyChoosedescription: "Get convenient pickup from your home, office, hotel, airport, or preferred location in Mumbai and direct drop service anywhere in Nagpur without the inconvenience of changing multiple transport options."
  },
  {
    WhyChooseheading: "Multiple Car Options for Every Requirement",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Booking",
    WhyChoosedescription: "Book a one-way taxi from Mumbai to Nagpur or select a round-trip package with flexible return schedules, waiting options, and customized travel plans."
  },
  {
    WhyChooseheading: "Perfect for Business, Family & Personal Travel",
    WhyChoosedescription: "Our Mumbai to Nagpur taxis are suitable for corporate visits, family vacations, educational trips, medical travel, relocation needs, and personal journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Highway Routes",
    WhyChoosedescription: "Our professional chauffeurs are experienced with Maharashtra highways and long-distance routes, ensuring safe driving, timely service, and a comfortable journey throughout the trip."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before every journey to provide passengers with a safe, hygienic, and relaxing travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Nagpur Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking assistance, professional chauffeur service, and reliable transportation for your Mumbai to Nagpur journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Mumbai to Nagpur?",
    answer: "Yes, you can book a private cab from Mumbai to Nagpur for a comfortable and direct long-distance journey."
  },
  {
    question: "Do you provide one-way cab service from Mumbai to Nagpur?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Mumbai to Nagpur."
  },
  {
    question: "Can I book a round-trip taxi to Nagpur?",
    answer: "Yes, round-trip cab packages are available with flexible return timing and customized travel schedules."
  },
  {
    question: "Which vehicles are available for Mumbai to Nagpur travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is Mumbai to Nagpur cab service suitable for family trips?",
    answer: "Yes, spacious vehicles and experienced drivers make the journey comfortable for families, children, and senior citizens."
  },
  {
    question: "Can I book an airport pickup from Mumbai for Nagpur travel?",
    answer: "Yes, airport pickup and direct transfer services from Mumbai Airport and Navi Mumbai Airport to Nagpur are available."
  },
  {
    question: "Can I customize stops during the Mumbai to Nagpur journey?",
    answer: "Yes, you can customize your travel plan with preferred stops, sightseeing locations, and route requirements."
  },
  {
    question: "How is the Mumbai to Nagpur cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip type, toll charges, parking fees, driver allowance, and additional travel requirements."
  },
  {
    question: "Are overnight journeys available from Mumbai to Nagpur?",
    answer: "Yes, overnight travel options are available according to your preferred departure schedule."
  },
  {
    question: "How can I book Mumbai to Nagpur Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger count, preferred vehicle, and trip type to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback: "We booked Mumbai to Nagpur cab service for a family trip. The vehicle was comfortable, the driver was professional, and the entire journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Excellent long-distance cab experience. The car was clean, the chauffeur was polite, and we reached Nagpur safely and comfortably.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nagpur Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-nagpur-cab.webp",
  "description":
    "Book Mumbai to Nagpur Cab with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for one-way trips, round trips, family travel, business journeys, and long-distance travel from Mumbai to Nagpur with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-nagpur-cab"
  }
};



    return (
        <div>
<Helmet>
  <title>Mumbai to Nagpur Cab | Outstation Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Nagpur Cab with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way trips, round trips, family travel, business journeys, and 24x7 cab booking from Mumbai to Nagpur."
  />

  <meta
    name="keywords"
    content="Mumbai to Nagpur Cab Booking, Mumbai to Nagpur Cab Service, Mumbai to Nagpur Taxi, Mumbai to Nagpur Cab, Mumbai to Nagpur Taxi Service, Mumbai Nagpur One Way Cab, Mumbai to Nagpur Car Rental, Mumbai Nagpur Outstation Cab, Mumbai to Nagpur Round Trip Taxi, Nagpur Taxi from Mumbai, Mumbai Nagpur Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitonagpurcab;